import { until } from '@vueuse/core'

import { useOrganization } from '~/composables/useOrganization'

export default defineNuxtRouteMiddleware(async () => {
  const { organization } = useOrganization()

  const { has_security_option } = await until(organization).toBeTruthy()

  if (!has_security_option) {
    return await navigateTo({
      name: 'index',
    })
  }
})
